import * as i0 from '@angular/core';
import { Component, Input, Injectable, NgModule } from '@angular/core';
import * as i1$1 from '@angular/router';
import { RouterModule } from '@angular/router';
import * as i2 from '@progress/kendo-angular-icons';
import { IconsModule } from '@progress/kendo-angular-icons';
import * as i1 from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import * as i5 from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';

class ExceptionDetailsComponent {
    title;
    errorMessage;
    stack;
    stackObject;
    constructor() { }
    _exception;
    get exception() {
        return this._exception;
    }
    set exception(value) {
        this._exception = value;
        this.parseException(this._exception);
    }
    ngOnInit() { }
    parseException(_exception) {
        if (_exception instanceof HttpErrorResponse) {
            this.parseHttpErrorResponse(_exception);
            return;
        }
        if (_exception instanceof Error) {
            this.parseError(_exception);
        }
        if (_exception instanceof Object && _exception.status) {
            this.parseHttpError(_exception);
        }
    }
    parseHttpErrorResponse(_exception) {
        this.title = _exception.name;
        this.errorMessage = _exception.message;
        this.stack =
            typeof _exception.error === 'string' ? _exception.error : undefined;
        if (typeof _exception.error !== 'string') {
            this.convertErrorObject(_exception.error);
            this.stackObject = _exception.error;
        }
    }
    parseError(_exception) {
        const e = this.convertError(_exception);
        this.title = e.title;
        this.errorMessage = e.errorMessage;
        this.stack = e.stack;
    }
    parseHttpError(_exception) {
        this.title = 'Http error: ' + _exception.status;
        this.errorMessage = _exception.message;
        this.convertErrorObject(_exception.error);
        this.stackObject = _exception.error;
    }
    convertErrorObject(object) {
        if (!object || !(object instanceof Object)) {
            return;
        }
        if (object instanceof Array) {
            for (const item of object) {
                this.convertErrorObject(item);
            }
        }
        for (const key of Object.keys(object)) {
            const value = object[key];
            if (value instanceof Array) {
                for (const item in value) {
                    this.convertErrorObject(item);
                }
            }
            if (value instanceof Error) {
                object[key] = this.convertError(value);
            }
        }
    }
    convertError(_exception) {
        return {
            title: _exception.name,
            errorMessage: _exception.message,
            stack: _exception.stack,
            original: _exception
        };
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ExceptionDetailsComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: ExceptionDetailsComponent, selector: "pl-exception-details", inputs: { exception: "exception" }, ngImport: i0, template: "<ng-container *ngIf=\"title || errorMessage || stack\">\n  <h4>{{title}}</h4>\n  <h5 *ngIf=\"errorMessage\">{{errorMessage}}</h5>\n  <pre *ngIf=\"stack\">{{stack}}</pre>\n  <pre *ngIf=\"stackObject\">{{stackObject|json}}</pre>\n  <div *ngIf=\"exception.internalError\" class=\"internal-error\">\n    <h5>Internal Error:</h5>\n    <pl-exception-details  [exception]=\"exception.internalError\"></pl-exception-details>\n  </div>\n</ng-container>\n<ng-container *ngIf=\"!title && !errorMessage && !stack\">\n  {{exception|json}}\n</ng-container>\n", styles: ["pre{max-width:80vw}.internal-error{padding-left:1rem;padding-top:1rem}:host{overflow:auto}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: ExceptionDetailsComponent, selector: "pl-exception-details", inputs: ["exception"] }, { kind: "pipe", type: i1.JsonPipe, name: "json" }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ExceptionDetailsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'pl-exception-details', template: "<ng-container *ngIf=\"title || errorMessage || stack\">\n  <h4>{{title}}</h4>\n  <h5 *ngIf=\"errorMessage\">{{errorMessage}}</h5>\n  <pre *ngIf=\"stack\">{{stack}}</pre>\n  <pre *ngIf=\"stackObject\">{{stackObject|json}}</pre>\n  <div *ngIf=\"exception.internalError\" class=\"internal-error\">\n    <h5>Internal Error:</h5>\n    <pl-exception-details  [exception]=\"exception.internalError\"></pl-exception-details>\n  </div>\n</ng-container>\n<ng-container *ngIf=\"!title && !errorMessage && !stack\">\n  {{exception|json}}\n</ng-container>\n", styles: ["pre{max-width:80vw}.internal-error{padding-left:1rem;padding-top:1rem}:host{overflow:auto}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { exception: [{
                type: Input
            }] } });

class ErrorPageComponent {
    route;
    router;
    errorData;
    showExceptionDetails;
    constructor(route, router) {
        this.route = route;
        this.router = router;
        this.route.data.subscribe((data) => {
            if (data['errorData'])
                this.errorData = data['errorData'];
        });
    }
    ngOnInit() { }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ErrorPageComponent, deps: [{ token: i1$1.ActivatedRoute }, { token: i1$1.Router }], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: ErrorPageComponent, selector: "pl-error-page", ngImport: i0, template: "<div class=\"wrapper\" *ngIf=\"errorData\">\n  <kendo-icon class=\"k-icon-xl k-color-error k-i-error\"></kendo-icon>\n  <h1 class=\"message\">Error: {{errorData.category}}{{errorData.code ? '-' + errorData.code : ''}}</h1>\n  <ng-container *ngIf=\"errorData\">\n    <h4> {{errorData.message || ('pl.errors.' + errorData.category + (errorData.code ? '-' + errorData.code : '')|translate)}}</h4>\n    <ng-container *ngIf=\"errorData.exception\">\n      <h5 (click)=\"showExceptionDetails=!showExceptionDetails\" class=\"exceptionDetails\">{{showExceptionDetails?'Hide':'Show'}} exception details</h5>\n      <pl-exception-details *ngIf=\"showExceptionDetails\" [exception]=\"errorData.exception\"></pl-exception-details>\n    </ng-container>\n  </ng-container>\n</div>\n", styles: [".wrapper{display:flex;flex-direction:column;align-items:center;justify-content:center;height:calc(100vh - 56px)}.wrapper h5.exceptionDetails{padding-top:2rem;font-weight:700;text-decoration:underline;cursor:pointer}\n"], dependencies: [{ kind: "component", type: i2.IconComponent, selector: "kendo-icon", inputs: ["name"], exportAs: ["kendoIcon"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: ExceptionDetailsComponent, selector: "pl-exception-details", inputs: ["exception"] }, { kind: "pipe", type: i5.TranslatePipe, name: "translate" }] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ErrorPageComponent, decorators: [{
            type: Component,
            args: [{ selector: 'pl-error-page', template: "<div class=\"wrapper\" *ngIf=\"errorData\">\n  <kendo-icon class=\"k-icon-xl k-color-error k-i-error\"></kendo-icon>\n  <h1 class=\"message\">Error: {{errorData.category}}{{errorData.code ? '-' + errorData.code : ''}}</h1>\n  <ng-container *ngIf=\"errorData\">\n    <h4> {{errorData.message || ('pl.errors.' + errorData.category + (errorData.code ? '-' + errorData.code : '')|translate)}}</h4>\n    <ng-container *ngIf=\"errorData.exception\">\n      <h5 (click)=\"showExceptionDetails=!showExceptionDetails\" class=\"exceptionDetails\">{{showExceptionDetails?'Hide':'Show'}} exception details</h5>\n      <pl-exception-details *ngIf=\"showExceptionDetails\" [exception]=\"errorData.exception\"></pl-exception-details>\n    </ng-container>\n  </ng-container>\n</div>\n", styles: [".wrapper{display:flex;flex-direction:column;align-items:center;justify-content:center;height:calc(100vh - 56px)}.wrapper h5.exceptionDetails{padding-top:2rem;font-weight:700;text-decoration:underline;cursor:pointer}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$1.ActivatedRoute }, { type: i1$1.Router }]; } });

class ErrorsService {
    router;
    currentErrors = [];
    constructor(router) {
        this.router = router;
    }
    addError(error) {
        this.currentErrors.push(error);
    }
    getLastError() {
        return this.currentErrors[this.currentErrors.length - 1];
    }
    /**
     * Adds error to errors list and redirects to error page.
     *
     * @param error - error to add
     * @param redirectAsLast -
     *            if true redirects to full error details with stack and message
     *            if false redirect to simple error page where only category code (and message if configured) will be displayed
     */
    async addAndRedirectToError(error, redirectAsLast = true) {
        this.addError(error);
        if (redirectAsLast) {
            return await this.redirectToLastError();
        }
        return await this.redirectToError(error);
    }
    /**
     * Redirect to error page for last added error. Full data from error will be used.
     */
    async redirectToLastError() {
        return await this.router.navigate(['/error']);
    }
    /**
     * redirects to simple error page.
     *
     * Stack and message from errorData will be ignored
     *
     * @param error
     */
    async redirectToError(error) {
        return await this.router.navigate(['/error', error.category, error.code]);
    }
    /**
     * Method that can be used as a handle in 'catchError' observable operator
     * Category and code parameters will be used as category and code for produced error.
     * Additionally raised exception will be passed to processing in error service and stacktrace message will be generated (if implemented)
     * @param category
     * @param code
     */
    handleObservableCatchError(category, code, message) {
        const self = this;
        return async function (err, caught) {
            await self.handleException(err, category, code, message);
            return false;
        };
    }
    /**
     * Method that can be used in any scenario where error/exception is available like try/catch exception.
     * Category and code parameters will be used as category and code for produced error.
     * Additionally raised exception will be passed to processing in error service and stacktrace message will be generated (if implemented)
     * @param exception
     * @param category
     * @param code
     */
    async handleException(exception, category, code, message) {
        await this.addAndRedirectToError({ category, code, exception, message }, !!exception);
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ErrorsService, deps: [{ token: i1$1.Router }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ErrorsService, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ErrorsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1$1.Router }]; } });

class ErrorDataResolver {
    errorService;
    constructor(errorService) {
        this.errorService = errorService;
    }
    resolve(route, state) {
        const category = route.paramMap.get('category') || 'unknown';
        const code = route.paramMap.get('code');
        if (category === 'unknown' || category === 'last') {
            return new Promise((resolve1, reject) => resolve1(this.errorService.getLastError()));
        }
        return new Promise((resolve1, reject) => resolve1({ category, code, message: '' }));
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ErrorDataResolver, deps: [{ token: ErrorsService }], target: i0.ɵɵFactoryTarget.Injectable });
    static ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ErrorDataResolver, providedIn: 'root' });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ErrorDataResolver, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: ErrorsService }]; } });

const routes = [
    {
        path: '',
        component: ErrorPageComponent,
        resolve: { errorData: ErrorDataResolver }
    },
    {
        path: ':category',
        component: ErrorPageComponent,
        resolve: { errorData: ErrorDataResolver }
    },
    {
        path: ':category/:code',
        component: ErrorPageComponent,
        resolve: { errorData: ErrorDataResolver }
    }
];
class ErrorsRoutingModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ErrorsRoutingModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: ErrorsRoutingModule, imports: [i1$1.RouterModule], exports: [RouterModule] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ErrorsRoutingModule, imports: [RouterModule.forChild(routes), RouterModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ErrorsRoutingModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [RouterModule.forChild(routes)],
                    exports: [RouterModule]
                }]
        }] });

class ErrorsModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ErrorsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: ErrorsModule, declarations: [ErrorPageComponent, ExceptionDetailsComponent], imports: [ErrorsRoutingModule, IconsModule, TranslateModule], exports: [ErrorPageComponent, ExceptionDetailsComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ErrorsModule, imports: [ErrorsRoutingModule, IconsModule, TranslateModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ErrorsModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [ErrorPageComponent, ExceptionDetailsComponent],
                    imports: [ErrorsRoutingModule, IconsModule, TranslateModule],
                    exports: [ErrorPageComponent, ExceptionDetailsComponent]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { ErrorDataResolver, ErrorPageComponent, ErrorsModule, ErrorsRoutingModule, ErrorsService, ExceptionDetailsComponent, routes };
